import React from "react";

// Material UI
import Button from "@mui/material/Button";

// React Router
import { Link } from "react-router-dom";

// Components
import logoNavbar from "../assets/img/logoNavbar.jpeg";
import Calcular from "../components/Home/Calcular";
import SobreSGIO from "../components/Home/SobreSGIO";

// Redux
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "../storeConfig/reducers/loginReducer";

const styles = {
	section: {
		minHeight: "70vh",
		backgroundColor: "#fafafa",
	},
	sectionColor: {
		backgroundColor: "#2B55B2", //"#D4DDEF",
		minHeight: "70vh",
		color: "white",
	},
};

const Home = () => {
	const isAuthenticated = useSelector(selectIsAuthenticated);

	return (
		<div style={{ backgroundColor: "#fafafa" }}>
			<section style={styles.section}>
				<img
					className="img-fluid mx-auto d-block p-5"
					width="600px"
					src={logoNavbar}
					alt="Logo do SGIO"
				/>

				<div>
					<h1 className="text-center text-break px-3">
						Sistema de Diagnóstico do Grau de Inovação das
						Organizações
					</h1>
					{isAuthenticated && (
						<div className="mt-4">
							<Link
								to="/form"
								className="nav-link d-flex justify-content-center"
							>
								<Button variant="contained">
									Calcular <br />
									Grau de Inovação
								</Button>
							</Link>
							<p className="fst-italic d-flex justify-content-center mt-1 text-center px-3">
								São apenas 12 quesitos. Você levará em torno de
								15 minutos para obter o grau de inovação.
							</p>
						</div>
					)}
				</div>
			</section>

			<section>
				<div style={styles.sectionColor} className="p-5">
					<SobreSGIO />
				</div>
			</section>

			<section>
				<div style={styles.section} className="p-5">
					<Calcular />
				</div>
			</section>
		</div>
	);
};

export default Home;
